import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import NavBar from '../Components/Stateless/NavBar';
import SideBar from '../Components/Stateless/SideBar';

const drawerWidth = 300;
const navBarHeight = 64;

const MainLayout = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <>
      <NavBar onDrawerToggle={handleDrawerToggle} />
      <SideBar open={drawerOpen} onClose={handleDrawerToggle} />
      <main
        style={{
          flexGrow: 1,
          padding: '24px',
          marginTop: `${navBarHeight}px`,
          marginLeft: drawerOpen ? `${drawerWidth}px` : '0',
          transition: 'margin-left 0.3s ease',
          boxSizing: 'border-box',
        }}
      >
        <Outlet />
      </main>
    </>
  );
};

export default MainLayout;
